import { render, staticRenderFns } from "./PageCom.vue?vue&type=template&id=42d8c1ed&"
import script from "./PageCom.vue?vue&type=script&lang=ts&"
export * from "./PageCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports